import Metismenu from "metismenujs";
import React, { Component, useContext, useEffect, useState, useCallback } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { getAdminCredentials, getAdminById } from "../../../api/AdminApi";
import { useDispatch } from "react-redux";
import { LOGOUT_ACTION } from "../../../store/actions/AuthActions";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }
  componentWillUnmount() { }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = (props) => {
  const { iconHover, sidebarposition, headerposition, sidebarLayout } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({});
  const [hideOnScroll, setHideOnScroll] = useState(true);

  const assigmentValue = useCallback(async () => {
    try {
      const credentials = await getAdminCredentials();
      const user = await getAdminById(credentials.IdUsuario);
      setUserData(user[0] || {});
    } catch (err) {
      console.error("Error fetching user data:", err);
      dispatch(LOGOUT_ACTION(props.history));
    }
  }, [dispatch, props.history]);

  useEffect(() => {
    assigmentValue();
  }, [assigmentValue]);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const fullPath = window.location.pathname;

  const isUsuarios = /^\/usuarios(\/|$)|\/fichausuario(\/|$)/.test(fullPath);
  const isClientes = /^\/clientes(\/|$)|\/Fichaclientes(\/|$)|\/Liquidacion(\/|$)/.test(fullPath);
  const isSesiones = /^\/sesiones(\/|$)|\/legajo(\/|$)/.test(fullPath);
  const isCierres = /^\/liquidaciones(\/|$)|^\/fichaliquidacion(\/|$)/.test(fullPath);
  const isOrdenDePago = /^\/ordendepago(\/|$)/.test(fullPath);
  const isPagos = /^\/pagos(\/|$)/.test(fullPath);
  const isOpciones = /^\/opciones(\/|$)/.test(fullPath);
  const isAdmin = /^\/admin(\/|$)/.test(fullPath);
  const isAlquileres = /^\/alquileres(\/|$)/.test(fullPath); // ✅ nueva ruta

  return (
    <div
      className={`dlabnav ${iconHover} ${sidebarposition.value === "fixed" &&
          sidebarLayout.value === "horizontal" &&
          headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
        }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <MM className="metismenu" id="menu">
          {userData.cuentas === "true" && (
            <li className={isUsuarios ? "mm-active" : ""}>
              <Link to="/usuarios" className="ai-icon">
                <i className="material-icons"> person </i>
                <span className="nav-text">Cuentas</span>
              </Link>
            </li>
          )}
          {userData.usuarios === "true" && (
            <li className={isClientes ? "mm-active" : ""}>
              <Link to="/clientes" className="ai-icon">
                <i className="material-icons"> person_add </i>
                <span className="nav-text">Usuarios</span>
              </Link>
            </li>
          )}
          {userData.sesiones === "true" && (
            <>
              <li className={isSesiones ? "mm-active" : ""}>
                <Link to="/sesiones" className="ai-icon">
                  <i className="material-icons"> check_circle </i>
                  <span className="nav-text">Operaciones</span>
                </Link>
              </li>


            </>
          )}
          {userData.cierres === "true" && (

            <>
              <li className={isCierres ? "mm-active" : ""}>
                <Link to="/liquidaciones" className="ai-icon">
                  <i className="material-icons"> description </i>
                  <span className="nav-text">Cierres</span>
                </Link>
              </li>

              {/* ✅ Nueva opción Alquileres visible si sesiones === "true" */}
              <li className={isAlquileres ? "mm-active" : ""}>
                <Link to="/alquileres" className="ai-icon">
                  <i className="material-icons"> business </i>
                  <span className="nav-text">Alquileres</span>
                </Link>
              </li>
              {/* ✅ Nueva opción App Clientes */}
              <li className={fullPath.startsWith("/appclientes") ? "mm-active" : ""}>
                <Link to="/appclientes" className="ai-icon">
                  <i className="material-icons"> smartphone </i>
                  <span className="nav-text">App Clientes</span>
                </Link>
              </li>
            </>
          )}
          {userData.cierres === "true" && (
            <li className={isOrdenDePago ? "mm-active" : ""}>
              <Link to="/ordendepago" className="ai-icon">
                <i className="material-icons"> payment </i>
                <span className="nav-text">Ordenes de Pagos</span>
              </Link>
            </li>
          )}
          {userData.cierres === "true" && (
            <li className={isPagos ? "mm-active" : ""}>
              <Link to="/pagos" className="ai-icon">
                <i className="material-icons"> payments </i>
                <span className="nav-text">Pagos</span>
              </Link>
            </li>
          )}
          {userData.opciones === "true" && (
            <li className={isOpciones ? "mm-active" : ""}>
              <Link to="/opciones" className="ai-icon">
                <i className="material-icons"> settings </i>
                <span className="nav-text">Opciones</span>
              </Link>
            </li>
          )}
          {(userData.IdTipoUsuario === "0" || userData.IdTipoUsuario === "2") && (
            <li className={isAdmin ? "mm-active" : ""}>
              <Link to="/admin" className="ai-icon">
                <i className="material-icons"> manage_accounts </i>
                <span className="nav-text">Admin</span>
              </Link>
            </li>
          )}
        </MM>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
